import { render, staticRenderFns } from "./WordImage.vue?vue&type=template&id=8a0e2340&scoped=true"
import script from "./WordImage.vue?vue&type=script&lang=js"
export * from "./WordImage.vue?vue&type=script&lang=js"
import style0 from "./WordImage.vue?vue&type=style&index=0&id=8a0e2340&prod&scoped=true&lang=scss"
import style1 from "./WordImage.vue?vue&type=style&index=1&id=8a0e2340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0e2340",
  null
  
)

export default component.exports